"use client"
import type { Client } from "@opensea/graphql"
import { prefetch } from "@opensea/graphql"
import { TOP_STATS_TABLE_PAGE_SIZE } from "./constants"
import { TopStatsTableQuery } from "./query"

export const prefetchStats = (client: Client) => {
  prefetch(client, TopStatsTableQuery, {
    limit: TOP_STATS_TABLE_PAGE_SIZE,
    sort: { by: "ONE_DAY_VOLUME", direction: "DESC" },
    filter: {},
  })
}
